"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalDevelop = exports.isUAT = exports.isAdorUat = exports.isAdorDomain = void 0;
var url_1 = require("utils/url");
var LITB_ADOR_DOMAIN = ["ador.com"];
exports.isAdorDomain = function () {
    var hostname = location.hostname;
    return LITB_ADOR_DOMAIN.some(function (domain) { return hostname.indexOf(domain) > -1; });
};
exports.isAdorUat = function () {
    return exports.isAdorDomain() && url_1.getSearchParamValue("litbuat");
};
exports.isUAT = function () {
    var hostname = window.location.hostname;
    return exports.isLocalDevelop() || hostname.indexOf("65emall.net") > -1 || !!exports.isAdorUat();
};
exports.isLocalDevelop = function () {
    var hostname = window.location.hostname;
    return (hostname.indexOf("192.168") > -1 ||
        hostname.indexOf("localhost") > -1 ||
        hostname.indexOf("127.0") > -1);
};
